export default __webpack_public_path__ + "static/sustainability_1-5e859436ee37cb607eb351c11d31f0e4.webp";